import { SVGProps } from 'react';

const Palette = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.5 7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M17.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6.5 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M8.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 22a10 10 0 0 1 0-20c2.652 0 5.196.948 7.071 2.636S22 8.613 22 11a5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M17.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6.5 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M8.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    />
  </svg>
);
export default Palette;
